import React, { useEffect, useState } from 'react';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import IFormError from '../../interfaces/IFormError';
import debounce from 'lodash.debounce';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import IWorkShift from '../../interfaces/IWorkShift';
import { useWorkShiftService } from '../../hooks/services/useWorkShiftService';

interface IProps {
  setWorkShift: (workShift: IWorkShift | null) => void;
  workShift: IWorkShift | null;
}

const SearchWorkShift = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<readonly IWorkShift[]>([]);
  const loadingInput = open;

  const request = useWorkShiftService();

  const toastr = useToastrVanila();

  const [errors, setErrors] = useState<IFormError | null>();

  useEffect(() => {
    let active = true;

    if (!loadingInput) {
      return undefined;
    }

    (async () => {
      if (active) {
        await loadWorkShifts(' - ');
      }
    })();

    return () => {
      active = false;
    };
  }, [loadingInput]);

  useEffect(() => {
    setErrors(null);
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const loadWorkShifts = debounce(async (filter = ' ') => {
    setLoading(true);
    await request
      .listWorkShiftSearch(filter)
      .then(workShifts => {
        setOptions(workShifts);
        setLoading(false);
      })
      .catch(error => {
        toastr.error(`Erro ao carregar os dados: ${error.message}`);
        setLoading(false);
      });
  }, 500);

  return (
    <Autocomplete
      open={open}
      value={props.workShift}
      onChange={(e: any, newValue) => {
        const castedWorkShift = { ...newValue } as IWorkShift;
        props.setWorkShift({ ...castedWorkShift });
      }}
      onOpen={() => {
        setOpen(true);
        props.setWorkShift(null);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => {
        return option?.description === value?.description;
      }}
      getOptionLabel={option => (option?.code && option.code ? `${option.code} - ${option.description}` : '')}
      options={options}
      loading={loading}
      renderInput={params => (
        <TextField
          {...params}
          label="Pesquisar Turno por código ou nome"
          error={Boolean(errors?.code)}
          helperText={errors?.code}
          size="small"
          onChange={e => {
            loadWorkShifts(e.target.value);
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default SearchWorkShift;
